import { all, call, fork, put, takeEvery } from "redux-saga/effects";
//Account Redux states
import { CANDIDATE, ORGANIZATION } from "../../../common/constant/LoginEnum";
import { REGISTER_USER, SOCIAL_REGISTER_USER } from "./actionTypes";
import {
  registerUserFailed,
  registerUserSuccessful,
  socialSignupSuccessful,
} from "./actions";

import {
  postFakeRegister,
  postJwtRegister,
  postSocialRegister,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      let url = constClass.REST_API_REGISTRATION_URL;

      //calling register api
      const response = yield call(postJwtRegister, url, user);

      yield put(registerUserSuccessful(response));
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeRegister, user);
      yield put(registerUserSuccessful(response));
    }
  } catch (error) {
    localStorage.removeItem("authUser");
    localStorage.setItem("isAuthProtected", false);
    yield put(registerUserFailed(error));
  }
}
function* socialSignup({ payload: { data, type, history } }) {
  try {
    let url;
    if (type === "google") {
      url = constClass.REST_API_SOCIAL_SIGNUP_GOOGLE;
    } else if (type === "microsoft") {
      url = constClass.REST_API_SOCIAL_SIGNUP_MICROSOFT;
    }
    const response = yield call(postSocialRegister, url, data);

    if (response.status !== undefined && response.status !== null) {
      if (response.type === CANDIDATE) {
        history.push({
          pathname: "/login/candidate",
          state: { successMessage: response.status },
        });
      } else if (response.type === ORGANIZATION) {
        // history.push({
        //   pathname: '/login/organization',
        //   state: { successMessage: response.status }
        // })
      }
    }
    yield put(socialSignupSuccessful(response));
  } catch (error) {
    localStorage.removeItem("authUser");
    localStorage.setItem("isAuthProtected", false);
    yield put(registerUserFailed(error));
  }
}

export function* watchUserRegister() {
  yield takeEvery(REGISTER_USER, registerUser);
  yield takeEvery(SOCIAL_REGISTER_USER, socialSignup);
}

function* accountSaga() {
  yield all([fork(watchUserRegister)]);
}

export default accountSaga;
